import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {empty} from '../../../functions';
import {alertMessages, AlertService} from '../../../shared/services/alert.service';
import {ValidationService} from '../../../shared/services/validation.service';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import { StudentProfileService } from '../../../api/services/student-profile.service';

@Component({
    selector: 'app-modal-student-profile-hobby',
    templateUrl: './modal-student-profile-hobby.component.html',
    styleUrls: ['./modal-student-profile-hobby.component.scss'],
    standalone: false
})
export class ModalStudentProfileHobbyComponent implements OnInit {

  // Data container for modal (contains entity data)
  public data:any;

  public profile_id = '';

  public entity = {
    id: '',
    description: ''
  }

  validation:any = {
    validated: false,
    valid: false,
    fields: {
      entity: {
        description: {
          regex: 'required',
          error: false
        },

      }
    }

  }

  /**
   * Constructor
   *
   * @param activeModal
   * @param studentService
   * @param alertService
   * @param validationService
   */
  constructor(public activeModal: NgbActiveModal,
              private studentProfileService: StudentProfileService,
              private alertService: AlertService,
              private validationService: ValidationService) {

  }

  /**
   * Ng init
   */
  ngOnInit(): void {
    if (!empty(this.data)) {

      this.profile_id = this.data.profile_id;
      this.entity = this.data.interest;

    }
  }

  /**
   * Show validation error
   *
   * Determine if a validation error needs to be visible to client
   *
   * @param stepNumber
   * @param $entity
   * @param $entityProperty
   */
  showValidationError($entity: string, $entityProperty: string, $property:string = '') {

    if (!empty($property)) {
      if (this.validation['validated'] && this.validation['validated']['fields'][$entity][$entityProperty][$property]['error'] === true) {
        return true;
      } else {
        return false;
      }
    } else {
      if (this.validation['validated'] && this.validation['fields'][$entity][$entityProperty]['error'] === true) {
        return true;
      } else {
        return false;
      }
    }

  }

  /**
   * Validate the registration form
   */
  validateForm() {
    let valid = true;
    const self:any = this;

    // Set entity data selectors
    const $entitySelectors = ['entity'];

    // Check entity columns
    for (const $entitySelector of $entitySelectors) {

      if ( this.validation['fields'].hasOwnProperty($entitySelector) ) {

        for (const key in this.validation['fields'][$entitySelector]) {

          if (!empty(this.validation['fields'][$entitySelector][key])) {

            const entity = this.validation['fields'][$entitySelector][key];

            if (entity.hasOwnProperty('regex') ) {
              const value = self[$entitySelector][key];
              const regPattern = entity['regex'];

              // Set validation flags
              if (!this.validationService.regexValidation(regPattern, value)) {
                this.validation['fields'][$entitySelector][key]['error'] = true;
                valid = false;

              } else {
                this.validation['fields'][$entitySelector][key]['error'] = false;
              }

            }
          }
        }
      }
    }

    // Set validation flags for step
    this.validation['valid'] = valid;
    this.validation['validated'] = true;

    return valid;
  }


  /**
   * Save data
   *
   * @constructor
   */
  Save() {

    const valid = this.validateForm();

    if (valid) {

      if (!empty(this.entity.id)) {

        this.studentProfileService.updateInterest({ profileId: this.profile_id, id: this.entity.id, body: this.entity }).pipe(catchError((err) => { this.alertService.errorWithReport(err, 'studentProfile:saveHobby'); return of(false as const); })).subscribe( (result) => {

          if (result !== false) {
            this.alertService.success(alertMessages.successDataSaved);
            this.activeModal.close(true);
          }

        });

      }
      else {

        const { id, ...body } = this.entity;
        this.studentProfileService.createInterest({ profileId: this.profile_id, body }).pipe(catchError((err) => { this.alertService.errorWithReport(err, 'studentProfile:saveHobby'); return of(false as const); })).subscribe( (result) => {

          if (result !== false) {
            this.alertService.success(alertMessages.successDataSaved);
            this.activeModal.close(true);
          }


        });

      }

    }

  }

}
